import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;

export const Side = styled.div`
  margin-top: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  width: 250px;
  padding-left: 20px;
`;

export const Main = styled.div`
  flex: 1;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

export const H2 = styled.h2`
  font-size: 20px;
  font-weight: 200;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 0 10px;
  align-self: flex-start;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Support = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;
